module.exports = __webpack_public_path__ + "assets/8d32c501b340c518b6b62b31eebb66ca.png";